// Categorias do site — leitura do BFF.
//
// Taxonomia PÚBLICA e hierárquica, separada da classificação de chamado do
// suporte (`Suporte.Categoria`): públicos e formas diferentes.
import apiClient from './client';
import { endpoints } from './endpoints';

export interface Categoria {
  idCategoria: number;
  Categoria: string;
  Slug: string;
  Descricao: string | null;
  Icone: string | null;
  Cor: string | null;
  UrlImagem: string | null;
  Sequencia: number | null;
  idCategoriaPai: number | null;
  Ativo: boolean;
}

export const categoryService = {
  async list(): Promise<Categoria[]> {
    const { data } = await apiClient.get<{ itens: Categoria[] }>(endpoints.categories.list);
    return data.itens ?? [];
  },

  /**
   * Monta a árvore a partir da lista plana. Feito no cliente porque o BFF
   * devolve tudo numa tacada (são poucas dezenas) — pedir por nível seria N+1
   * requisições para desenhar um menu.
   */
  async tree(): Promise<Array<Categoria & { filhas: Categoria[] }>> {
    const todas = await this.list();
    const porPai = new Map<number, Categoria[]>();
    for (const c of todas) {
      if (c.idCategoriaPai == null) continue;
      const irmas = porPai.get(c.idCategoriaPai) ?? [];
      irmas.push(c);
      porPai.set(c.idCategoriaPai, irmas);
    }
    return todas
      .filter((c) => c.idCategoriaPai == null)
      .map((c) => ({ ...c, filhas: porPai.get(c.idCategoria) ?? [] }));
  },
};
